import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "payment-button-container" }
const _hoisted_2 = { class: "sub-header" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "payment-button-body"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "payment-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12 0C5.3868 0 0 5.3868 0 12C0 18.6132 5.3868 24 12 24C18.6132 24 24 18.6132 24 12C24 5.3868 18.6132 0 12 0ZM12 2.4C17.3161 2.4 21.6 6.68385 21.6 12C21.6 17.3161 17.3161 21.6 12 21.6C6.68385 21.6 2.4 17.3161 2.4 12C2.4 6.68385 6.68385 2.4 12 2.4ZM10.8 4.8V12.4969L15.9516 17.6484L17.6484 15.9516L13.2 11.5031V4.8H10.8Z",
      fill: "#e23d35"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_6 = { class: "payment-description" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "payment-info" }, "Use your balance", -1 /* HOISTED */)
const _hoisted_8 = { class: "payment-text" }
const _hoisted_9 = {
  key: 1,
  class: "payment-button-body"
}
const _hoisted_10 = {
  key: 0,
  class: "payment-icon"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  width: "46",
  height: "32",
  viewBox: "0 0 46 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5 0C2.25 0 0 2.25 0 5V27C0 29.75 2.25 32 5 32H41C43.75 32 46 29.75 46 27V5C46 2.25 43.75 0 41 0H5ZM5 2H41C42.668 2 44 3.33203 44 5V7H2V5C2 3.33203 3.33203 2 5 2ZM2 12H44V27C44 28.668 42.668 30 41 30H5C3.33203 30 2 28.668 2 27V12ZM7 15V17H23V15H7Z",
    fill: "#F2C94C"
  })
], -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "payment-icon"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  width: "23",
  height: "12",
  viewBox: "0 0 23 12",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M22.1533 9.23031V11.0764C22.1533 11.4327 21.9475 11.7576 21.6253 11.9109C21.3032 12.0641 20.922 12.017 20.645 11.7909L11.0767 3.96152L1.50735 11.7909C1.23135 12.017 0.850133 12.0632 0.527064 11.9109C0.203995 11.7586 0 11.4327 0 11.0764L0 9.23031C0 8.9534 0.124612 8.69125 0.338761 8.51587L10.4924 0.208379C10.833 -0.0694606 11.3213 -0.0694606 11.6619 0.208379L21.8155 8.51587C22.0287 8.69125 22.1533 8.9534 22.1533 9.23031Z",
    fill: "#CFCFCF"
  })
], -1 /* HOISTED */)
const _hoisted_15 = { class: "payment-description" }
const _hoisted_16 = {
  key: 0,
  class: "payment-info"
}
const _hoisted_17 = {
  key: 1,
  class: "payment-info"
}
const _hoisted_18 = {
  key: 2,
  class: "payment-info"
}
const _hoisted_19 = { class: "payment-text" }
const _hoisted_20 = {
  key: 2,
  class: "payment-button-body unselected"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "chevy" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "23",
    height: "12",
    viewBox: "0 0 23 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M22.1533 9.23031V11.0764C22.1533 11.4327 21.9475 11.7576 21.6253 11.9109C21.3032 12.0641 20.922 12.017 20.645 11.7909L11.0767 3.96152L1.50735 11.7909C1.23135 12.017 0.850133 12.0632 0.527064 11.9109C0.203995 11.7586 0 11.4327 0 11.0764L0 9.23031C0 8.9534 0.124612 8.69125 0.338761 8.51587L10.4924 0.208379C10.833 -0.0694606 11.3213 -0.0694606 11.6619 0.208379L21.8155 8.51587C22.0287 8.69125 22.1533 8.9534 22.1533 9.23031Z",
      fill: "#CFCFCF"
    })
  ])
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString($props.withdraw ? "Account" : "Payment Method"), 1 /* TEXT */),
    _createElementVNode("button", {
      class: "payment-button outline",
      onClick: _withModifiers($setup.selectPayment, ["stop"])
    }, [
      ($setup.selectedPayment == 'useBalance')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, "Opt Balance $" + _toDisplayString(Math.abs($setup.balances.available.value).toFixed(2)), 1 /* TEXT */)
            ])
          ]))
        : (typeof $setup.selectedPayment !== 'string' && $setup.selectedPayment?.paymentMethodId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              ($setup.selectedPayment.type == 'credit')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                : ($setup.selectedPayment.type == 'bank')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createCommentVNode("TODO: Replace placeholder image here"),
                      _hoisted_14
                    ]))
                  : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_15, [
                ($setup.selectedPayment.type == 'credit')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Credit Card"))
                  : ($setup.selectedPayment.type == 'bank')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, "Bank Account"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_18, "Payment Method")),
                _createElementVNode("div", _hoisted_19, _toDisplayString($setup.selectedPayment.nickname), 1 /* TEXT */)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString($props.withdraw ? "Select Account" : "Select Payment Method"), 1 /* TEXT */)),
      _hoisted_21
    ], 8 /* PROPS */, _hoisted_3),
    ($setup.showPaymentSelect && $setup.userFinancial)
      ? (_openBlock(), _createBlock($setup["PaymentSelectWindow"], {
          key: 0,
          price: $setup.props.price,
          dontClose: $setup.showPaymentInput,
          userFinancial: $setup.userFinancial,
          paymentMethods: $setup.paymentMethods,
          withdraw: $props.withdraw,
          onAddPaymentMethod: _cache[0] || (_cache[0] = ($event: any) => ($setup.showPaymentInput = true)),
          onUseBalance: $setup.onUseBalance,
          onSelectInfo: $setup.selectInfo,
          onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.showPaymentSelect = false))
        }, null, 8 /* PROPS */, ["price", "dontClose", "userFinancial", "paymentMethods", "withdraw"]))
      : _createCommentVNode("v-if", true),
    ($setup.showPaymentInput)
      ? (_openBlock(), _createBlock($setup["PaymentInputWindow"], {
          key: 1,
          price: $setup.props.price,
          stripe: $setup.stripe,
          withdraw: $props.withdraw,
          onCreatePaymentInfo: $setup.createPaymentInfo,
          onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.showPaymentInput = false))
        }, null, 8 /* PROPS */, ["price", "stripe", "withdraw"]))
      : _createCommentVNode("v-if", true)
  ]))
}